var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b1b1b1"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.4175409,45.063925 C -1.2574941,35.17533 -2.9875731,14.969886 5.2981159,6.3062708 13.92449,-2.7135722 35.129721,-1.9767912 45.518936,7.9979648 84.51724,45.440388 114.62629,77.16446 149.17996,111.74771 c 33.69197,33.72081 68.5019,67.01113 101.07593,101.16244 9.18895,9.63387 6.45759,28.70748 -1.88426,36.67769 -7.95498,7.60052 -26.17637,9.30335 -35.21713,0.38828 C 177.28075,214.60115 145.77054,182.53448 112.07857,148.81368 77.52489,114.23043 46.659668,84.15018 8.4175409,45.063925 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 247.58246,45.063873 c 9.67504,-9.888595 11.40511,-30.09404 3.11943,-38.7576542 -8.62637,-9.019844 -29.83161,-8.283062 -40.22082,1.691694 C 171.48275,45.440336 141.3737,77.16441 106.82003,111.74765 73.12807,145.46847 38.318137,178.75879 5.7441129,212.9101 c -9.188954,9.63386 -6.45759499,28.70748 1.884258,36.67768 7.9549741,7.60053 26.1763691,9.30335 35.2171341,0.38828 C 78.71925,214.60109 110.22946,182.53442 143.92142,148.81362 178.47512,114.23037 209.34034,84.15013 247.58246,45.063873 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.57122eb5cb4f0721f8d90aea92cdb030.svg";
export { ForwardRef as ReactComponent };